/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Credit card rental car CDW/LDW coverage information
 * @export
 * @interface RentalCarCoverage
 */
export interface RentalCarCoverage {
    /**
     * The credit card product name (present for MX-matched cards)
     * @type {string}
     * @memberof RentalCarCoverage
     */
    creditCardProductName?: string;
    /**
     * The detected network tier (present for tier-based lookups)
     * @type {string}
     * @memberof RentalCarCoverage
     */
    networkTier?: string;
    /**
     * Whether coverage is primary (pays first) or secondary (supplements auto insurance)
     * @type {string}
     * @memberof RentalCarCoverage
     */
    coverageType: RentalCarCoverageCoverageTypeEnum;
    /**
     * Maximum rental duration covered in days
     * @type {number}
     * @memberof RentalCarCoverage
     */
    maxCoverageDays?: number;
    /**
     * Human-readable coverage description
     * @type {string}
     * @memberof RentalCarCoverage
     */
    summary: string;
    /**
     * Whether coverage came from exact card match or network tier defaults
     * @type {string}
     * @memberof RentalCarCoverage
     */
    source: RentalCarCoverageSourceEnum;
}


/**
 * @export
 */
export const RentalCarCoverageCoverageTypeEnum = {
    Primary: 'primary',
    Secondary: 'secondary',
    None: 'none'
} as const;
export type RentalCarCoverageCoverageTypeEnum = typeof RentalCarCoverageCoverageTypeEnum[keyof typeof RentalCarCoverageCoverageTypeEnum];

/**
 * @export
 */
export const RentalCarCoverageSourceEnum = {
    CardRegistry: 'card_registry',
    NetworkTier: 'network_tier'
} as const;
export type RentalCarCoverageSourceEnum = typeof RentalCarCoverageSourceEnum[keyof typeof RentalCarCoverageSourceEnum];


/**
 * Check if a given object implements the RentalCarCoverage interface.
 */
export function instanceOfRentalCarCoverage(value: object): value is RentalCarCoverage {
    if (!('coverageType' in value) || value['coverageType'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function RentalCarCoverageFromJSON(json: any): RentalCarCoverage {
    return RentalCarCoverageFromJSONTyped(json, false);
}

export function RentalCarCoverageFromJSONTyped(json: any, ignoreDiscriminator: boolean): RentalCarCoverage {
    if (json == null) {
        return json;
    }
    return {
        
        'creditCardProductName': json['credit_card_product_name'] == null ? undefined : json['credit_card_product_name'],
        'networkTier': json['network_tier'] == null ? undefined : json['network_tier'],
        'coverageType': json['coverage_type'],
        'maxCoverageDays': json['max_coverage_days'] == null ? undefined : json['max_coverage_days'],
        'summary': json['summary'],
        'source': json['source'],
    };
}

export function RentalCarCoverageToJSON(json: any): RentalCarCoverage {
    return RentalCarCoverageToJSONTyped(json, false);
}

export function RentalCarCoverageToJSONTyped(value?: RentalCarCoverage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credit_card_product_name': value['creditCardProductName'],
        'network_tier': value['networkTier'],
        'coverage_type': value['coverageType'],
        'max_coverage_days': value['maxCoverageDays'],
        'summary': value['summary'],
        'source': value['source'],
    };
}

